import o from "./_isStrictComparable.js";
import l from "./keys.js";
function f(a) {
  for (var t = l(a), r = t.length; r--; ) {
    var e = t[r], i = a[e];
    t[r] = [e, i, o(i)];
  }
  return t;
}
export {
  f as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_getMatchData.js
// module id = 1513
// module chunks = 67